import React from "react"
import Layout from "../components/Layout"
import Banner from "../components/Banner"
import About from "../components/Home/About"
import Services from "../components/Home/Services"
import StyledHero from "../components/StyledHero"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import FeaturedTours from "../components/Home/FeaturedTours"
import services from "../constants/services"
import SEO from "../components/SEO"
export default ({ data }) => (
  <Layout>
    <SEO title="PK Greben" />
    <StyledHero home="true" img={data.defaultBcg.childImageSharp.fluid}>
      <Banner title="greben" info=" Planinarski Klub">
        <Link to="/najave" className="btn-white">
          pogledaj naše akcije
        </Link>
   <Link to="/postani-clan" className="btn-white"  style={{ display: "block", marginTop: "1rem" }}>
    postani član
  </Link>
      </Banner>
    </StyledHero>
    <About />
    <Services  services={services}/>
    <FeaturedTours />
  </Layout>
)
export const query = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "defaultBcg.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
